import { render, staticRenderFns } from "./assignInterpreter.vue?vue&type=template&id=0b0f5496&scoped=true&"
import script from "./assignInterpreter.vue?vue&type=script&lang=js&"
export * from "./assignInterpreter.vue?vue&type=script&lang=js&"
import style0 from "./assignInterpreter.vue?vue&type=style&index=0&id=0b0f5496&lang=less&scoped=true&"
import style1 from "./assignInterpreter.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f5496",
  null
  
)

export default component.exports